import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 font-bold" }, " AGREGAR ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_AdminRegister = _resolveComponent("AdminRegister")!
  const _component_EmployeeRegister = _resolveComponent("EmployeeRegister")!
  const _component_ResidentRegister = _resolveComponent("ResidentRegister")!
  const _component_ExtinguisherRegister = _resolveComponent("ExtinguisherRegister")!
  const _component_PetRegister = _resolveComponent("PetRegister")!
  const _component_GasRegister = _resolveComponent("GasRegister")!
  const _component_FormHandleRegister = _resolveComponent("FormHandleRegister")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "text-primary-400 flex",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAdd && _ctx.openAdd(...args)))
    }, [
      _hoisted_1,
      _createVNode(_component_mdicon, {
        name: "plus-thick",
        class: "self-start"
      })
    ]),
    (_ctx.showAdminRegister)
      ? (_openBlock(), _createBlock(_component_AdminRegister, {
          action: _ctx.typeMethods,
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          visible: _ctx.showAdminRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["action", "onReload", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showEmployeeRegister)
      ? (_openBlock(), _createBlock(_component_EmployeeRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showEmployeeRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showResidentRegister)
      ? (_openBlock(), _createBlock(_component_ResidentRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showResidentRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showExtinguisherRegister)
      ? (_openBlock(), _createBlock(_component_ExtinguisherRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showExtinguisherRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showPetRegister)
      ? (_openBlock(), _createBlock(_component_PetRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showPetRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showGasRegister)
      ? (_openBlock(), _createBlock(_component_GasRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showGasRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true),
    (_ctx.showHandleRegister)
      ? (_openBlock(), _createBlock(_component_FormHandleRegister, {
          key: _ctx.keyIndexInvestModal,
          onReload: _ctx.reload,
          action: _ctx.typeMethods,
          visible: _ctx.showHandleRegister,
          onCloseAction: _ctx.closeAction
        }, null, 8, ["onReload", "action", "visible", "onCloseAction"]))
      : _createCommentVNode("", true)
  ]))
}